module.exports = __webpack_public_path__ + "static/media/smile1.cc9fde2b.gif";